import { dropAllDatabases } from "@rocicorp/zero";
import { useZero } from "@rocicorp/zero/react";
import { useCallback } from "react";
import { signOut } from "../components/SignIn/lib/sso";

export function useLogout() {
  const z = useZero();
  return useCallback(async () => {
    // Legacy IndexedDB deletes can block on another tab, so sign-out never waits on them.
    const cleanup = Promise.allSettled([z.delete(), dropAllDatabases()]);
    await signOut();
    localStorage.clear();
    sessionStorage.clear();
    const failed = (await cleanup).find((r) => r.status === "rejected");
    if (failed) throw failed.reason;
  }, [z]);
}
